'use client';

import * as React from 'react';
import {PopupMenu, MenuItem} from '@purpose/ui/components';
import {cn} from '@purpose/ui/lib/utils';

export type IconMenuItemProps = {
  id: number;
  name: string;
  onClick: () => void | Promise<void>;
};

export type IconMenuProps = IconMenuItemProps[];

export interface IconWithPopupProps {
  Icon: React.ReactNode;
  title?: string;
  menuProps: IconMenuProps;
  className?: string;
}

const IconWithPopup = ({
  Icon,
  title,
  menuProps,
  className
}: IconWithPopupProps) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  function handleClick(event: React.MouseEvent<HTMLElement>) {
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }
  }

  function handleClose() {
    setAnchorEl(null);
  }

  return (
    <div className={cn('content-center', className)}>
      <div
        onClick={handleClick}
        aria-owns={anchorEl ? 'simple-menu' : undefined}
        aria-haspopup="true"
        className="flex cursor-pointer flex-col items-center justify-center"
      >
        {Icon}
      </div>
      <PopupMenu
        id="simple-menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        minWidth={250}
        slotProps={{
          paper: {
            sx: {
              width: '250px'
            }
          }
        }}
      >
        {title && (
          <MenuItem
            label={title}
            disabled
            sx={{fontWeight: 600, opacity: '1 !important'}}
          >
            {title}
          </MenuItem>
        )}
        {menuProps.map((option, index) => (
          <MenuItem
            key={option.id}
            label={option.name}
            onClick={async () => {
              await option.onClick();
              handleClose();
            }}
            sx={{
              width: '100% !important',
              borderBottom:
                index !== menuProps.length - 1 ? 'solid 1px #EEE' : 'none'
            }}
          >
            {option.name}
          </MenuItem>
        ))}
      </PopupMenu>
    </div>
  );
};

export {IconWithPopup};
